module.exports = __webpack_public_path__ + "media/images/fancybox_loading-78a563f0ad9e9a354f51b1dfcbd81991.gif";